import ChartLineCollectionDecorator from '@/components/graph/ChartLineCollectionDecorator';

export default class SimpleChartLineCollection extends ChartLineCollectionDecorator {}
